var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('typeform',{staticClass:"quiz",attrs:{"id":"form","form-id":"wZceT36U","container-id":"form"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }